// import { gql } from '@apollo/client';

// export const USERLOGIN = gql`
//   mutation userLogin($userName: String!, $password: String!) {
//     userLogin(authDto: { userName: $userName, password: $password })
//   }
// `;

// export const GET_USER_INFO = gql`
//   query user($id: ID) {
//     user(id: $id) {
//       id
//       roles {
//         id
//         name
//       }
//       permissions {
//         id
//         name
//         permissionName
//       }
//     }
//   }
// `;

import { gql } from '@apollo/client';

export const USERLOGIN = gql`
  mutation userLogin($userName: String!, $password: String!) {
    userLogin(authDto: { userName: $userName, password: $password })
  }
`;

// Note: This mutation returns a string token directly, not an object

export const GET_USER_INFO = gql`
  query user($id: ID) {
    user(id: $id) {
      id
      email
      firstName
      lastName
      deviceId
      fcmToken
      roles {
        id
        name
      }
      permissions {
        id
        name
        permissionName
      }
    }
  }
`;

// New query to fetch all roles dynamically
export const GET_ALL_ROLES = gql`
  query {
    roles {
      id
      name
      createdAt
    }
  }
`;

export const GET_ROLES_WITH_PERMISSIONS = gql`
  query roles {
    roles {
      id
      name
      permissions {
        id
        name
        permissionName
      }
    }
  }
`;
